/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Page, Group, Copy, Title, BodyCopy, Link } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './passwordupdated_styles';
// import styles from 'pages/auth/requestdemo/requestdemo_styles';




/* ========== ~~~~~~~~~~ AUTH PASSWORD UPDATED ~~~~~~~~~~ ========== */
class PasswordUpdatedPage extends Component {
    render() {
        return(
            <Page name={`passwordupdated`} klass={this.props.classes.passwordupdated}>
                <Group name={`main`}>
                    <Copy>
                        <Title>
                            <h2>Password Updated</h2>
                        </Title>
                        <BodyCopy>
                            <p>{`Successfully updated the password${!!this.props.email ? ` for ${this.props.email}.` : `.`}`}</p>
                            <p>Continue and <Link type={`internal`} action={`auth/signin`} text={`Log In`} color={`primary`} /></p>
                        </BodyCopy>
                    </Copy>
                </Group>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PasswordUpdatedPage);
